import { useContext } from 'react';

import { KaseContext } from '@/contexts';

export const useKaseContext = () => useContext(KaseContext);
